var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    iphone: _vm.isIPhone()
  },attrs:{"id":"app"}},[_c('error-dialog'),_c('router-view',{staticClass:"no-drag",attrs:{"id":"wrap"}},[_c('global-header',{ref:"headerRef"})],1),(!_vm.serviceAppkey)?_c('global-footer',{ref:"footerRef"}):_vm._e(),_c('dimmed'),_c('portal-target',{attrs:{"name":"bgBlur"}}),_c('portal-target',{attrs:{"name":"dimmed"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }